import { talk_send } from '@/components/utils/common_func_axios';
import { getCurrentDateTime } from '@/components/utils/common';
import eventBus from '@/components/utils/eventBus';

function DOMLoaded() {
	console.info('TalkJS-DOMLoaded()');

	/*
	// 엔터키 전송 추가
	document.addEventListener('keyup', function(e) {
		//e.target.classList.contains('talk_content')
		if (e.target.id === 'content') {
			if (e.key === 'Enter') { // 엔터키
				const content = document.getElementById('content');
				if (content.value.replace(/[\s\n]/g, '') === '' || !content.value || content.value.trim() === '' || content.value.trim().length < 1) {
					e.preventDefault();
					content.value = '';
					toast.fire({
						icon: "error",
						title: '내용이 없습니다.'
					});
					return false;
				} else {
					document.querySelector('.send_btn').click();
				}
			}
		}
	});
	*/

	talkScroll();
}

// .scrollTop 변환
function talkScroll() {
	const talkInner = document.querySelector('.aiTalkWrap .talk_inner');
	if (talkInner) {
		talkInner.scrollTop = talkInner.scrollHeight;
	}
}

async function talkSend(event, mb_id, mb_boss_id, other_id, content, aiorder_id) {
console.log(content);
// console.log( content.replace(/[\s\n]/g, '') );
	if (!content || content.trim() === '' || content.trim().length < 1) {
		event.preventDefault();
		content = '';
		toast.fire({
			icon: "error",
			title: '내용이 없습니다.'
		});
		return false;
	}

	const data = {
		mb_id: mb_id,
		mb_boss_id: mb_boss_id,
		other_id: other_id,
		content: content.replace(/\n/g, '') // 240826 줄바꿈제거
	};

	if (typeof aiorder_id !== 'undefined') {
		data.aiorder_id = aiorder_id;
	}

	const result = await talk_send(data);

	if (result.result === 'success') {
		talkAppend();
	} else {
		toast.fire({
			icon: "error",
			title: result.msg,
		});
		return false;
	}
}

const talkAppend = () => {
	const todaytime = getCurrentDateTime();
	// .talk_inner 요소를 선택
	const talkInner = document.querySelector('.talk_inner');
	const talk_content = document.querySelector('.talk_content')

	if (talkInner) {
		// HTML 문자열을 생성
		const newMessage = `
		<div class="talk_me">
			<div class="message_box">${talk_content.value}
			<div class="time">${todaytime}</div>
			</div>
		</div>
		`;

		// HTML을 요소에 추가
		talkInner.insertAdjacentHTML('beforeend', newMessage);
		// 톡 내용
		talk_content.value = '';
		// 전송해야됨
		eventBus.emit('update-talkcontent', '');

		talkScroll();
	}
}

export { DOMLoaded, talkSend }